import React from 'react';
import './BookCard.css';

function BookCard({ book, onClick }) {
  const status = book.readingStatus || book.status;
  
  const getStatusClass = (status) => {
    switch (status) {
      case 'reading': return 'status-reading';
      case 'finished': return 'status-finished';
      case 'toRead': return 'status-to-read';
      case 'to-read': return 'status-to-read';
      default: return 'status-to-read';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'reading': return 'Reading';
      case 'finished': return 'Finished';
      case 'toRead': return 'To Read';
      case 'to-read': return 'To Read';
      default: return 'To Read';
    }
  };

  return (
    <div className="book-card" onClick={() => {
      console.log('BookCard clicked:', book.title);
      onClick();
    }} style={{ cursor: 'pointer' }}>
      <div className="book-cover">
        {(book.imageUrl || book.thumbnail) ? (
          <img src={book.imageUrl || book.thumbnail} alt={`${book.title} cover`} />
        ) : (
          <div className="book-cover-placeholder">
            <div className="book-spine"></div>
            <div className="book-title">{book.title}</div>
          </div>
        )}
        <div className="book-overlay">
          <span className={`reading-status ${getStatusClass(status)}`}>
            {getStatusLabel(status)}
          </span>
          {book.rating && (
            <div className="rating-badge">
              ⭐ {book.rating}
            </div>
          )}
        </div>
      </div>
      <div className="book-info">
        <h3 className="book-title-text">{book.title}</h3>
        <p className="book-author">
          {book.authors?.join(', ') || book.author || 'Unknown Author'}
        </p>
      </div>
    </div>
  );
}

export default BookCard;